import React, {createContext, useState} from 'react';

const VaControllerContext = createContext({
    store: {
        autoOpen: true,
        chatWidgetCounter: 0,
        eventsInfo: {},
        isLoading: false,
        showVA: false,
        vaIntent: '',
    },
    actions: {
        updateVaController: () => {},
        updateIsLoading: () => {},
    },
});

const VaControllerProvider = (props) => {
    const [store, setStore] = useState({
        autoOpen: true,
        chatWidgetCounter: 0,
        eventsInfo: {},
        isLoading: false,
        showVA: false,
        vaIntent: '',
    });
    const [actions] = useState({
        updateVaController: (
            autoOpen = true,
            eventsInfo = {},
            vaIntent = ''
        ) => {
            setStore((lastStore) => ({
                ...lastStore,
                autoOpen,
                chatWidgetCounter: lastStore.chatWidgetCounter + 1,
                eventsInfo,
                vaIntent,
                showVA: true,
            }));
        },
        updateIsLoading: (isLoading) => {
            setStore((lastStore) => ({...lastStore, isLoading}));
        },
    });

    return (
        <VaControllerContext.Provider value={{store, actions}}>
            {props.children}
        </VaControllerContext.Provider>
    );
};

export {VaControllerContext, VaControllerProvider};
